import tippy from "tippy.js";
import LazyLoad from "vanilla-lazyload";
import lightbox from "../modules/lightbox";

const templateQuality = {
  init: function () {
    this.video();
    this.advantages();
    this.gallery.init();
  },

  video: function () {
    // On click load video and play it
    $(".video-wrap").on("click", function (e) {
      let video = $(this);
      if (!video.hasClass("playing")) {
        e.preventDefault();
        video.addClass("playing");
        $(".video-play__btn", video).fadeOut();
        let video_dom = $(".video-wrap__video", video);
        console.log("#" + video.attr("id") + " .video-wrap__video");

        video = new LazyLoad({
          elements_selector: "#" + video.attr("id") + " .video-wrap__video",
        });

        setTimeout(function () {
          video_dom.addClass("video-wrap__video--active");
          video_dom[0].play();
        }, 250);
      }
    });
  },

  advantages: function () {
    let rows_in_block = $(".advantages-table").data("block");
    let rows = $(".advantages-table__content .advantages-table__row");

    let more_btn = $(".advantages__more .more");
    if (rows.length >= rows_in_block) {
      more_btn.removeClass("read-more--hidden");
    }

    more_btn.on("click", function (e) {
      e.preventDefault();
      let hidden_rows = rows.not(".active");

      // Load more
      let i = 1;
      hidden_rows.each(function () {
        $(this).slideDown(400).addClass("active");
        if (i == rows_in_block) return false;
        i++;
      });

      // Hide btn
      if (hidden_rows.length <= rows_in_block) {
        more_btn.hide();
      }
    });

    tippy(".wine-supports__info__circle", {
      placement: "right",
      arrow: true,
    });
  },

  gallery: {
    loading: false,
    main: $(".gallery-slider"),
    thumbs: $(".gallery-thumbs"),

    init: function () {
      if ($(".gallery-block").length) {
        this.change_type();
      }
    },

    change_type: function () {
      $(".gallery-block__nav__item").on("click", function (e) {
        e.preventDefault();
        if (templateQuality.gallery.loading) {
          return;
        }
        let id = $(this).data("type");
        $(this)
          .addClass("gallery-block__nav__item--active")
          .siblings()
          .removeClass("gallery-block__nav__item--active");
        templateQuality.gallery.load_type(id);
      });
    },

    load_type: function (id) {
      if (templateQuality.gallery.loading) {
        return;
      }
      templateQuality.gallery.loading = true;

      let nonce = $("#nonce").val();
      $.ajax({
        url: ajaxurl,
        type: "POST",
        data: {
          action: "change_gallery",
          type_id: id,
          nonce: nonce,
        },
        beforeSend: function (xhr) {
          $(".gallery-block__type").addClass("loading");
        },
        success: function (response) {
          if (response.success) {
            $(".gallery-block__type").html(response.data.gallery);
            lightbox.gallery.content();
          }

          setTimeout(function () {
            templateQuality.gallery.loading = false;
            $(".gallery-block__type").removeClass("loading");
          }, 250);
        },
      });
    },
  },
};

export default templateQuality;
